
export const Config  = {
     base_url: 'https://www.nitishpatel.in/api/BasinExplorer/'
}